import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import CSVService, { CSVFile, CSVQueryFilterDto } from '@/services/CSVService';

export const GET_CSVS_QUERY_KEY = (
  queryFilterDto?: Partial<CSVQueryFilterDto>,
) => ['csvs', { ...queryFilterDto }];

export function useGetCsvs(queryFilterDto?: Partial<CSVQueryFilterDto>) {
  const { data, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: GET_CSVS_QUERY_KEY(queryFilterDto),
      initialPageParam: 1,
      queryFn: ({ pageParam }) =>
        CSVService.getCsvs({
          ...queryFilterDto,
          page: pageParam,
          limit: queryFilterDto?.limit ?? 12,
        }),
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const data = lastPage;

        if (data.currentPage === data.totalPages || data.totalPages === 0) {
          return null;
        }

        return lastPageParam + 1;
      },
    });

  const csvs = useMemo(() => {
    return data?.pages
      .flatMap((page) => page?.items)
      .reduce((acc: CSVFile[], csv) => {
        acc.push(csv);
        return acc;
      }, []);
  }, [data?.pages]);

  return {
    csvs: csvs ?? [],
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
}
